// extracted by mini-css-extract-plugin
export default {"component":"ToggleVat_component__l-Um8"};